import { QueryFactory } from "../../../../Common";
import { BReporting } from "../../../../Contracts";
export const QGetSettledBets = QueryFactory(BReporting.QueryTypes.GetSettledBets);
//# sourceMappingURL=QGetSettledBets.js.map